export default __webpack_public_path__ + "static/media/game.1eafe819.png";